import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=199bf24c&scoped=true&"
import script from "./SettingsView.vue?vue&type=script&lang=js&"
export * from "./SettingsView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=199bf24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199bf24c",
  null
  
)

export default component.exports